import { coreDefaultTheme, DottedProgressTheme } from '@kite-js/theme';
import colors from '@theme/rurubu/theme-rurubu/colors';

const dottedProgressTheme: DottedProgressTheme = {
    ...coreDefaultTheme.dottedProgress!,
    dotColors: [colors.blue[500], colors.blue[500], colors.blue[500], colors.blue[500], colors.blue[500]],
};

export default dottedProgressTheme;
